require('../../modules/es6.array.is-array');
module.exports = require('../../modules/_core').Array.isArray;



/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/fn/array/is-array.js
 ** module id = 823
 ** module chunks = 0
 **/